import React from "react"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../_metronic/_helpers"

const ICON_DEFAULT_FILL_COLOR = "#4A4A68"
const ICON_DEFAULT_HEIGHT = "2rem"
const ICON_DEFAULT_WIDTH = "2rem"
const ICON_DEFAULT_ARIA_LABEL = "SVG icon"
/**
 * Utility function to render an SVG icon with support for multiple paths
 * @param {Object} props - Props passed to the RenderImgFileAsSvg component
 * @param {string} props.src - Path or URL to the SVG file
 * @param {Object} [props.style] - Optional custom styles for the SVG
 * @param {string} [props.className] - Optional className for additional CSS styling
 * @param {string} [props.fill] - Optional dynamic fill color for the SVG icon
 * @returns {JSX.Element}
 */
export function RenderImgFileAsSvg({ src, style, className, fill, ...props }) {
	return (
		<SVG
			{...props}
			className={className}
			style={{
				...style,
				height: ICON_DEFAULT_HEIGHT,
				width: ICON_DEFAULT_WIDTH,
				fill: fill || ICON_DEFAULT_FILL_COLOR
			}}
			src={toAbsoluteUrl(src)}
			aria-label={props?.alt || ICON_DEFAULT_ARIA_LABEL}
		/>
	)
}
